import axiosClient from './axiosClient';

const adminCategoryService = {
    getAll: async (params = {}) => {
        const response = await axiosClient.get('/admin/categories/all', { params });
        return response.data;
    },
    getById: async (id) => {
        const response = await axiosClient.get(`/admin/categories/${id}`);
        return response.data;
    },
    create: async (payload) => {
        const response = await axiosClient.post('/admin/categories/create', payload);
        return response.data;
    },
    update: async (id, payload) => {
        const response = await axiosClient.put(`/admin/categories/${id}`, payload);
        return response.data;
    }
};

export default adminCategoryService;
